import { createRoutine } from 'redux-saga-routines';

export const searchPosItems = createRoutine('SEARCH_POS_ITEMS');
